import { render, staticRenderFns } from "./ExternalLinks.1.vue?vue&type=template&id=15c41e71&"
import script from "./ExternalLinks.1.vue?vue&type=script&lang=js&"
export * from "./ExternalLinks.1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eric/projects/musical/musical-admin-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15c41e71')) {
      api.createRecord('15c41e71', component.options)
    } else {
      api.reload('15c41e71', component.options)
    }
    module.hot.accept("./ExternalLinks.1.vue?vue&type=template&id=15c41e71&", function () {
      api.rerender('15c41e71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExternalLinks.1.vue"
export default component.exports